






















import { Component, Prop, Vue } from 'vue-property-decorator';
import Flatpickr from 'vue-flatpickr-component';
import { randomId } from '@/helpers';
import { TransitionExpand } from 'vue-transition-expand';

@Component({ components: { Flatpickr, TransitionExpand } })
export default class DatetimePicker extends Vue {
  @Prop({ required: false, type: String }) readonly label?: string;
  // We could pass it throught $attrs as well, but in this case vee-validate would not be able to see the value.
  @Prop() readonly value!: any;
  @Prop({ required: false, type: String, default: () => randomId('datetimepicker') }) readonly id!: string
  @Prop({ type: Boolean, default: false }) readonly danger!: boolean;
  @Prop({ type: String, default: '' }) readonly dangerText!: string;
}
